import axios, { AxiosRequestConfig, AxiosInstance } from 'axios';
import { getToken } from '../helpers/Token';
import communityUrls from "../configs/community/communityUrls";

interface ApiInterface extends AxiosInstance {
  oneSky?: any;
}

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  config.headers ||= {};
  config.headers['Content-Type'] = 'application/json';
  config.headers['Authorization'] = `Bearer ${getToken()}`;

  return config;
}

const communityApi: ApiInterface = axios.create({ baseURL: communityUrls.baseURL })
communityApi.interceptors.request.use(onRequest);

communityApi.oneSky = {
  url: communityUrls.remoteUrl.bind(communityUrls),
  uploadHeaders: {
    'Authorization': `Bearer ${getToken()}`
  }
}

export default communityApi;
